import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { MessageService } from "primeng/api";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { RestService } from "../../services/rest.service";
import { ToasterService } from "../../services/toaster-service";
import { MessageEnum } from "../../utils/message.enum";
import { TestReportSummarizationActions } from "../actions/report-summarization.action";

@Injectable()
export class TestReportSummarizationEffects {
  @BlockUI() blockUI!: NgBlockUI;
  private messageService = inject(MessageService);

  constructor(private actions$: Actions, private restService: RestService, private toaster: ToasterService) { }

  loadTestReportSummarization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TestReportSummarizationActions.loadTestReportSummarization),
      mergeMap((action) => {
        const { view, projectId, requestParam } = action;
        const payload = { view, projectId, requestParam };

        return this.restService.getReportSummarization(payload).pipe(
          map((response: any) => {
            this.blockUI.stop();
            const metricGroups = response.metricGroups?.filter((item: any) => item.metrics?.length > 0);
            return TestReportSummarizationActions.loadTestReportSummarizationSuccess(
              { metadata: response.metadata, testReport: metricGroups.sort((a: any, b: any) => a.order - b.order) }
            );
          }),
          catchError((error) => {
            this.blockUI.stop();
            let errorMessage = error?.message ? error?.message : MessageEnum.TEST_REPORT_SUMMARY_LOAD_FAILURE
            this.toaster.pop({ type: 'error', text: errorMessage });
            return of(
              TestReportSummarizationActions.loadTestReportSummarizationFailure(
                {
                  error,
                }
              )
            );
          })
        );
      })
    )
  );
}
